import * as PIXI from "pixi.js";
import {app, events, gameData, openCardsSound, scratchSound, ticker} from "../../utils/pixiApp";
import TWEEN from "@tweenjs/tween.js";
import {getTileDeviceMedia} from "../../utils/sizes";
import {Texture} from "pixi.js";

const sizes = {
    web: {
        width: 354,
        height: 354,
        imgSize: 338,
        padding: 8,
    },
    mobileSxx: {
        width: 126,
        height: 126,
        padding: 8,
    },
    mobileSx: {
        width: 126,
        height: 126,
        padding: 8,
    },
    mobileSm: {
        width: 190,
        height: 190,
    },
    mobileXs: {
        width: 220,
        height: 220,
    },
    mobileXxs: {
        width: 250,
        height: 250,
    }
}

export const style = {
    fontSize: 96,
    textTransform: 'uppercase',
    fontFamily: "Rubik",
    textShadow: '2px 0 0 #5e5e5e, 0 2px 0 #5e5e5e, -2px 0 0 #5e5e5e, 0 -2px 0 #5e5e5e',
    fill: '#dce5e9',
    fontWeight: '500',
    lineHeight: 96,
    "stroke": "#5f5f60",
    dropShadowColor: '#3d4349',
    dropShadowDistance: 3,
    dropShadow: true,
    "dropShadowAngle": 0.5,
    "strokeThickness": 2
}

export const getTextSize = (size) => {
    if(size === 'mobileSx') {
        return {
            baseFont: {
                fontSize: 34
            },
            winFont: {
                fontSize: 44
            }
        }
    }
    if(size === 'mobile') {
        return {
            baseFont: {
                fontSize: 50
            },
            winFont: {
                fontSize: 60
            }
        }
    }
    else {
        return {
            baseFont: {
                fontSize: 96
            },
            winFont: {
                fontSize: 124
            }
        }
    }
}

export const test = {
    align: "center",
    breakWords: true,
    dropShadow: true,
    dropShadowAngle: 0.8,
    dropShadowColor: "#92a9be",
    dropShadowDistance: 3,
    fill: "#dce5e9",
    fontFamily: "Rubik",
    fontSize: 96,
    fontWeight: 500,
    letterSpacing: 1,
    // lineHeight: 70,
    padding: 10,
    lineJoin: "round",
    verticalAlign: 'middle',
    miterLimit: 0,
    stroke: "#768b98",
    strokeThickness: 4,
    wordWrap: true,
    wordWrapWidth: 500
}


export const shadowStyle = {
    dropShadowColor: "#030f17",
    stroke: "#522301",
    dropShadowDistance: 4,
    dropShadowAngle: 0.4,
}

export class Tile extends PIXI.Container {
    constructor() {
        super();
        this.isRenderGroup = true
        this.filters = null
        this.mediaScreen = getTileDeviceMedia(app.screen.width)
        this.dragging = false;
        this.points = [];
        this.brushRadius = 60;
        this.maxCircles = this.mediaScreen === 'web' ? 2 : 1;
        this.imgSize = sizes.web.imgSize;
        this.count = 0;
        this.rect = new PIXI.Rectangle(0,0, sizes.web.width, sizes.web.height);
        this.text = new PIXI.BitmapText({ text: String(this.count).replace(".",","), style: new PIXI.TextStyle({...test}) });
        this.main = new PIXI.Container();
        this.main.filters = null;

        this.text.anchor.set(.5,.5)
        this.text.position.x = sizes.web.width / 2
        this.text.position.y = sizes.web.height / 4 * 3.14;
        this.border = new PIXI.Sprite(PIXI.Texture.from('tileRect'));
        this.border.setSize(sizes.web.width, sizes.web.height);
        this.border.position.set(0,0);

        this.card = new PIXI.Sprite(PIXI.Texture.from('1'));
        this.card.setSize(sizes.web.width, sizes.web.height);
        this.card.position.set(0,0);

        this.thing = new PIXI.Rectangle(0,0,sizes.web.width,sizes.web.height);
        this.renderTexture = PIXI.RenderTexture.create({width: 354, height: 354, antialias: true});
        // this.renderTexture = app.renderer.generateTexture({
        //     target: originalContainer,
        //     frame: this.thing,
        //     resolution: 1,
        // });
        console.log(this.renderTexture)
        this.renderTextureSprite = new PIXI.Sprite(this.renderTexture);

        this.main.addChild(this.card, this.border, this.text);

        this.brush = new PIXI.Sprite(PIXI.Texture.from('brush'));
        this.circleBrush = new PIXI.Sprite(PIXI.Texture.from('circleBrush'));
        this.brush.setSize(this.brushRadius * 2, this.brushRadius * 2);
        this.circleBrush.setSize(this.brushRadius * 2, this.brushRadius * 2);
        this.brush.anchor.set(.5,.5);
        this.circleBrush.anchor.set(.5,.5);
        this.circleBrush.position.set(this.border.width / 2, this.border.height / 2)

        this.bg = new PIXI.Sprite(PIXI.Texture.from('activeCard'));
        this.ng = new PIXI.Sprite(PIXI.Texture.from('closeCard'));
        this.ng.setSize(sizes.web.width, sizes.web.height)
        this.bg.setSize(sizes.web.width, sizes.web.height)

        this.main.mask = this.renderTextureSprite;
        this.main.mask.alpha = 1;
        this.addChild(this.bg, this.main, this.renderTextureSprite, this.ng)

        this.setMeshAnimate()
        this.setFireAnim()

        this.on("pointermove", this.onPointerMove);
        this.on("pointerdown", this.onPointerOver);
        this.on("pointerupoutside", this.onPointerOut);
        this.on("pointerup", this.onPointerOut);

        this.on('START_TILE', this.onStartTile.bind(this))
        this.on('REVAL_TILE', this.reveal.bind(this))

        // const colorStops = ['rgba(255,255,255,1)'];
        // const gradient = new PIXI.FillGradient(0, 0, 227, 0);
        //
        // colorStops.forEach((number, index) =>
        // {
        //     const ratio = index / colorStops.length;
        //
        //     gradient.addColorStop(ratio, number);
        // });
        // const graphic1 = new PIXI.Graphics().ellipse(100, 100, 50, 150).fill('rgba(255,255,255,1)');
        // graphic1.filters = [new PIXI.BlurFilter(30)]
        // window.test = graphic1
        // graphic1.rotation = 5
        // graphic1.alpha = .5
        // this.renderTexture = PIXI.RenderTexture.create({width:354, height: 354});
        // this.renderTextureSprite = new PIXI.Sprite(this.renderTexture);
        // this.renderTextureSprite.mask = graphic1
        // this.addChild(this.renderTextureSprite, graphic1)

        this.TWEEN = TWEEN;
        ticker.add((time) => this.TWEEN.update(time.deltaTime * 0.01))
        events.onScreenResizeEvent(() => {
            this.resizeView();
        })
    }

    onPointerOver() {
        this.dragging = true;
    }

    onPointerOut() {
        this.dragging = false;
        this.soundScratchPause()
    }

    onPointerMove(event) {
        if (this.dragging) {
            this.soundScratchPlay();
            const point = event.data.getLocalPosition(this);
            this.brush.rotation = Math.random() * Math.PI;
            this.brush.position.set(point.x, point.y);

            app.renderer.render({
                container: this.brush,
                target: this.renderTexture,
                clear: false,
                skipUpdateTransform: true,
            });

            if (point.x < this.brushRadius) {
                point.x = this.brushRadius;
            }
            if (point.y < this.brushRadius) {
                point.y = this.brushRadius;
            }
            if (point.x > this.width - this.brushRadius) {
                point.x = this.width;
            }
            if (point.y > this.height - this.brushRadius) {
                point.y = this.height;
            }

            if (this.points.length === 0) {
                this.points.push(point);
            }
            else {
                const len = this.points.length;
                for (let i = 0; i < len; i++) {
                    if (this.pointInCircle(this.points[i], point, this.brushRadius)) {
                        return;
                    }
                }
                this.points.push(point);
                if (len >= this.maxCircles) {
                    this.reveal();
                }
            }
        }
    }

    pointInCircle(pA, pB, radius) {
        const dx = pA.x - pB.x;
        const dy = pA.y - pB.y;
        const distancesquared = dx * dx + dy * dy;
        return distancesquared <= radius * radius;
    }

    reveal() {
        this.soundScratchPause()
        this.openCardsPlay()
        this.dragging = false;
        this.eventMode = 'none';

        this.brush.position.set(this.border.width / 2, this.border.height / 2)
        this.brush.setSize(100,100)
        const revalAnim = new this.TWEEN.Tween({scale: 1}).to({scale: 4}, 500).onUpdate(obj => {
            this.brush.scale.set(obj.scale);
            this.brush.rotation = Math.random() * Math.PI *  Math.trunc(obj.scale);
            app.renderer.render({
                container: this.brush,
                target: this.renderTexture,
                clear: false,
                skipUpdateTransform: true,
            });
            }).onComplete(() => {
                this.main.mask = null
                this.brush.scale.set(1)
            })

        revalAnim.start()
        gameData.setGameData('wasStarted', true)
        this.points = []
        this.emit("revealed", this);
    }

    async onStartTile(data) {
        console.log('tileTexture', data.tileTexture)
        this.removeFire();
        this.points = []
        this.eventMode = 'static';
        this.cursor = 'pointer'
        this.count = data.bet;
        this.brushStartAnimate(data)

        // this.main.mask = this.renderTextureSprite;
        // this.renderTextureSprite.texture = this.renderTexture;
        // const tileTexture = data.tileTexture

        // setTimeout(() => {
        //     this.text.text = String(this.count).replace(".",",")
        //     this.text.style = new PIXI.TextStyle({...test, ...{fill: '#dce5e9'}})
        //     this.card.texture = tileTexture
        // }, 500)

    }

    soundScratchPlay() {
        if(gameData.getGameData('sound') && !scratchSound.playing()) {
            scratchSound.play()
        }
    }

    soundScratchPause() {
        scratchSound.pause()
    }

    openCardsPlay() {
        if(gameData.getGameData('sound') && !scratchSound.playing()) {
            openCardsSound.play()
        }
    }

    async brushStartAnimate(data) {
        const tileTexture = data.tileTexture
        const setTileData = () => {
            this.text.text = String(this.count).replace(".",",")
            this.text.style = {...test, ...{fill: '#dce5e9'}}
            this.card.texture = Texture.from(tileTexture)
            this.border.texture = Texture.from('tileRect')
        }
        const startAnim = new this.TWEEN.Tween({scale: 5}).to({scale: 0}, 600).onUpdate(obj => {
            this.circleBrush.scale.set(obj.scale);
            app.renderer.render({
                container: this.circleBrush,
                target: this.renderTexture,
                clear: true,
                skipUpdateTransform: true,
            });
        }).onComplete(() => {

            setTileData()
            // app.renderer.render({
            //     container: this,
            //     clear: true,
            // });
            this.circleBrush.scale.set(1)
        })

        if(gameData.getGameData('wasStarted')) {

            this.main.mask = this.renderTextureSprite;
            startAnim.start()
        } else {
            setTileData()
            this.newGameAnimate();

            setTimeout(() => {
                this.brush.scale.set(0);
                app.renderer.render({
                    container: this.brush,
                    target: this.renderTexture,
                    skipUpdateTransform: true,
                });
                this.brush.scale.set(1)
            }, 500)
        }
    }

    newGameAnimate() {
        this.removeChild(this.ng)
        this.addChild(this.meshAnim)
        this.meshAnim.play()
    }

    setMeshAnimate() {
        this.meshFrames = [];

        for (let i = 0; i < 24; i++)
        {
            this.meshFrames.push(PIXI.Texture.from(`mesh${i + 1}.png`));
        }
        this.meshAnim = new PIXI.AnimatedSprite(this.meshFrames);
        this.meshAnim.position.set(sizes.web.width / 2, sizes.web.height / 2);
        this.meshAnim.anchor.set(.5,.5)
        this.meshAnim.setSize(sizes.web.width, sizes.web.height)
        this.meshAnim.animationSpeed = .3
        this.meshAnim.onLoop = () => {
            this.meshAnim.stop()
            this.removeChild(this.meshAnim)
            this.meshAnim.destroy()
        }
    }
    setFireAnim() {
        this.startFireFrames = []
        for (let i = 0; i < 14; i++)
        {
            this.startFireFrames.push(PIXI.Texture.from(`fireStart${i + 1}.png`));
        }
        this.startFireAnim = new PIXI.AnimatedSprite(this.startFireFrames);
        this.startFireAnim.position.set(sizes.web.width / 2, sizes.web.height / 2);
        this.startFireAnim.anchor.set(.5,.5)
        this.startFireAnim.setSize(sizes.web.width + 18, sizes.web.height + 18)
        this.startFireAnim.animationSpeed = .3

        this.fireFrames = []
        for (let i = 0; i < 30; i++)
        {
            this.fireFrames.push(PIXI.Texture.from(`fireCicle${i + 1}.png`));
        }
        this.fireAnim = new PIXI.AnimatedSprite(this.fireFrames);
        this.fireAnim.position.set(sizes.web.width / 2, sizes.web.height / 2);
        this.fireAnim.anchor.set(.5,.5)
        this.fireAnim.setSize(sizes.web.width + 18, sizes.web.height + 18)
        this.fireAnim.animationSpeed = .3
        this.startFireAnim.onLoop = () => {

            this.startFireAnim.stop()
            this.addChild(this.fireAnim)
            this.removeChild(this.startFireAnim)

            this.fireAnim.play()
        }
    }
    startFire() {
        this.addChild(this.startFireAnim)
        setTimeout(() => this.startFireAnim.play(), 500)
    }

    removeFire() {
        console.log(this.children.length)
        if(this.children.length > 3) {
            this.fireAnim.stop()
            this.removeChild(this.fireAnim)
        }
    }

    resizeView() {
        this.mediaScreen = getTileDeviceMedia(app.screen.width)
        this.maxCircles = this.mediaScreen === 'web' ? 2 : 1;
    }
}